<ng-container>
    <!-- Only when the group actually names itself. Every group in the model is
         an unlabelled { items: [...] }, so without the label check this printed
         an empty div per group - zero height, but carrying 0.75rem of margin
         top and bottom, which is where the sidebar's phantom spacing came from. -->
    @if (root && item.label && item.visible !== false) {
        <div class="layout-menuitem-root-text">
            {{ item.label }}
        </div>
    }
    @if ((!item.routerLink || item.items) && item.visible !== false) {
        <a
            role="button"
            tabindex="0"
            [attr.data-testid]="item.testId"
            (click)="itemClick($event)"
            (keydown.enter)="itemClick($event)"
            (keydown.space)="itemClick($event)"
            [ngClass]="item.styleClass"
        >
            <!-- ICON -->
            <i [ngClass]="item.icon" class="layout-menuitem-icon"></i>

            <!-- LABEL -->
            <span class="layout-menuitem-text">
                {{ item.label }}
            </span>

            <!-- BADGE -->
            @if (item.badge) {
                <span
                    class="ml-auto min-w-[20px] h-5 px-2 flex items-center justify-center text-[11px] font-semibold text-[var(--primary-contrast-color)] bg-[var(--primary-color)] rounded-full"
                >
                    {{ item.badge }}
                </span>
            }

            <!-- ARROW -->
            @if (item.items) {
                <i class="pi pi-fw pi-angle-down layout-submenu-toggler"></i>
            }
        </a>
    }
    @if (item.routerLink && !item.items && item.visible !== false) {
        <a
            [attr.data-testid]="item.testId"
            (click)="itemClick($event)"
            [ngClass]="item.styleClass"
            [routerLink]="item.routerLink"
            routerLinkActive="active-route"
            [routerLinkActiveOptions]="
                item.routerLinkActiveOptions || {
                    paths: 'exact',
                    queryParams: 'ignored',
                    matrixParams: 'ignored',
                    fragment: 'ignored',
                }
            "
        >
            <i [ngClass]="item.icon" class="layout-menuitem-icon"></i>
            <span class="layout-menuitem-text">{{ item.label }}</span>
            @if (item.items) {
                <i class="pi pi-fw pi-angle-down layout-submenu-toggler"></i>
            }
            @if (item.badge) {
                <span
                    class="ml-auto min-w-[20px] h-5 px-2 flex items-center justify-center text-[11px] font-semibold text-[var(--primary-contrast-color)] bg-[var(--primary-color)] rounded-full"
                >
                    {{ item.badge }}
                </span>
            }
        </a>
    }
    @if (item.items && item.visible !== false) {
        <ul [@children]="submenuAnimation">
            @for (child of item.items; track child; let i = $index) {
                <li
                    app-menuitem
                    [item]="child"
                    [index]="i"
                    [parentKey]="key"
                    [class]="child['badgeClass']"
                ></li>
            }
        </ul>
    }
</ng-container>
